export default {
  TableHead: [
    [
      {
        displayName: 'banner.datatable.number',
      },
      {
        displayName: 'banner.datatable.image',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'banner.datatable.status',
      },
      {
        displayName: 'banner.datatable.order',
      },
      {
        displayName: 'banner.datatable.edit',
      },
      {
        displayName: 'banner.datatable.delete',
      },
    ],
  ],
  initialModel() {
    return {
      images: '',
      sort: '',
      isActive: true,
    };
  },
};
